import API from '../../api/api';
import Auth from '../../auth.js';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import React, {Component} from 'react';
import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import '../../styles/css/passwords/passwordReset.css';
import '../../styles/css/passwords/resetPassword.css';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';

class ResetPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formInputs: {},
            errors: {},
            message: '',
            loading: false,
            showInvalidToken: false,
            showResetPassword: false,
        };


        this.doSubmit = this.doSubmit.bind(this);
        this.catchInputChange = this.catchInputChange.bind(this);
    }

    componentDidMount() {
        API.post(`user/find_reset/` + this.props.match.params.token, [])
            .then(response => {
                console.log(response);
                const formInputs = this.state.formInputs;
                formInputs["token"] = response.data.data.token;
                formInputs["email"] = response.data.data.email;

                this.setState({
                    message: '',
                    invalidToken: false,
                    formInputs: formInputs,
                    showInvalidToken: false,
                    showResetPassword: true,
                });
            })
            .catch(error => {
                this.setState({
                    message: error.response.data.message,
                    showInvalidToken: true,
                    showResetPassword: false,
                });
            });
    }

    catchInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        const formInputs = this.state.formInputs;
        formInputs[name] = value;

        this.setState({
            formInputs: formInputs
        });
    }

    doSubmit(event) {
        event.preventDefault();
        this.setState({
            loading: true
        });
        this.handleResetPassword();
    }

    handleResetPassword() {
        API.post(`user/reset_password`, this.state.formInputs)
            .then(res => {
                console.log(res, "success");
                this.setState({
                    errors: {},
                    formStatus: {
                        message: res.data.response,
                        status: "alert alert-success"
                    },
                    showEmailSent: true,
                    loading: false,
                });

                Auth.logout(() => {
                    this.props.history.push("/signin");
                });

            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
                this.setState({
                    errors: err.response.data.error,
                    formStatus: {
                        message: err.response.data.message,
                        status: "alert alert-danger"
                    },
                    loading: false,
                });
            });
    }

    openPanel() {
        document.getElementById("resetPanel").style.opacity = "1";
    }

    checkPasswords() {
        var password = document.getElementById("password").value;
        var password_confirmation = document.getElementById("password_confirmation").value;
        var message = document.getElementById("matchPasswords");
        var changeBtn = document.getElementById("changePw");

        if (password !== '') {
            if (password === password_confirmation) {
                message.innerHTML = "Matched!";
                message.style.color = "#6f6";
                changeBtn.style.opacity = "1";
            } else {
                message.innerHTML = "Not matched!";
                message.style.color = "#f66";
                changeBtn.style.opacity = "0.7";
            }
        }

    }

    render() {
        const {classes} = this.props;
        return (
            <div onLoad={this.openPanel} className={`${classNames(classes.session)} mainDiv`}>
                <img className="common_updots" src="/static/images/common_updots.svg" alt="common_updots"/>
                <img className="common_downdots" src="/static/images/common_downdots.svg" alt="common_downdots"/>
                <div className={classes.content}>
                    <div className={classes.wrapper}>
                        <Card className="resetPanel" id="resetPanel">
                            <CardContent className={this.state.showInvalidToken ? '' : classes.hidden}>
                                <div className="text-xs-center pb-xs">
                                    <h1>Invalid/Expired Token</h1>
                                    <Typography variant="body1">
                                        This password reset token is in-valid or expired.
                                    </Typography>
                                    <div className="pt-1 text-xs-center alreadyAcc">
                                        <span>Forgot password?&nbsp;</span>
                                        <Link className="" to="/forgot">Click here</Link>
                                    </div>
                                </div>

                            </CardContent>
                            <CardContent className={this.state.showResetPassword ? '' : classes.hidden}>
                                <form onSubmit={this.doSubmit}>
                                    <div className="text-xs-center pb-xs">
                                        <h1 className="resetPwordHead">Change password</h1>
                                    </div>
                                    <TextField
                                        id="password"
                                        name="password"
                                        label="New password"
                                        className={`${classes.textField} resetLabel ${this.state.errors.password ? 'loginInput' : ''}`}
                                        fullWidth
                                        margin="normal"
                                        onChange={this.catchInputChange}
                                        type="password"
                                        helperText={this.state.errors.password ? this.state.errors.password[0] : ''}
                                    />
                                    <TextField
                                        id="password_confirmation"
                                        name="password_confirmation"
                                        label="Confirm new password"
                                        className={`${classes.textField} resetLabel ${this.state.errors.password_confirmation ? 'loginInput' : ''}`}
                                        fullWidth
                                        margin="normal"
                                        onChange={this.catchInputChange}
                                        onKeyUp={this.checkPasswords}
                                        type="password"
                                        helperText={this.state.errors.password_confirmation ? this.state.errors.password_confirmation[0] : ''}
                                    />
                                    <div className="matchPasswords">
                                        <span id="matchPasswords">&nbsp;</span>
                                    </div>
                                    <CircularProgress className={this.state.loading ? '' : classes.hidden}/>
                                    <input className="changePw" id="changePw" value="Change Password" type="submit"/>
                                    <div className="pt-1 text-xs-center alreadyAcc">
                                        <span>Already have an account?&nbsp;</span>
                                        <Link className="" to="/signin">Sign in</Link>
                                    </div>
                                </form>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </div>
        );
    }
}

ResetPassword.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default ResetPassword;


// WEBPACK FOOTER //
// ./src/pages/Users/ResetPassword.js